import { setState } from './helpers'

const promotionMutations = {
  SET_SALES_PROMOTIONS: setState('salesPromotions'),
  SET_PROMO_FILTERS: setState('promoFilters'),
  SET_PROMOTION_LIST: setState('promotionList'),
  SET_PROMOTION: setState('promotion')
}

export { promotionMutations }
